import api from './api';

const resource = 'Feedback/';

export async function apiCustomerOrderFeedback(data) {
  return await api.post(resource + 'customerorderfeedback', data);
}

export async function apiGetCustomerOrderFeedbackByOrder(orderId) {
  return await api.get(resource + 'customerorderfeedback/by-order/' + orderId);
}

export async function apiGetCustomerOrderFeedbackStore(storeId) {
  return await api.get(resource + 'customerorderfeedback/by-store/' + storeId);
}

// Admin (platform-wide) paged listing for the Ratings dashboard.
export async function apiListOrderFeedbacks(query = '') {
  return await api.get(resource + 'customerorderfeedback/list' + query);
}

export async function apiListApplicationFeedbacks(query = '') {
  return await api.get(resource + 'applicationfeedback/list' + query);
}
